import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';

@Component({
  selector: 'ae-underwriting-info',
  templateUrl: './underwriting-info.component.html',
  styleUrls: ['./underwriting-info.component.scss']
})
export class UnderwritingInfoComponent implements OnInit {
  constructor(private router: Router, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.loaderService.hide();
  }
  nextClick() {
    this.router.navigate(['/bind']);
  }
}
